import { format } from "date-fns";

import type { AdvisorInfoSchema } from "@fartherfinance/frontend/api/Entity/Types";
import type {
  FamOnboardingStatus,
  OnboardingStatus,
  RegistrationStatus,
  Sentiment,
  TransitionDetailsDTO,
  TransitionDTO,
  TransitionPhase,
  TransitionStatus,
} from "@fartherfinance/frontend/api/TransitionWorkflows/Types";
import { isTransitionComplete } from "@fartherfinance/frontend/api/TransitionWorkflows/utils/isTransitionComplete";

export const formatTransitionDate = (date: Date): string => {
  return format(date, "MM/dd/yyyy");
};

// Status mappings
export const registrationStatusMap: Record<RegistrationStatus, string> = {
  NotRegistered: "Not Registered",
  Registered: "Registered",
  DualRegistered: "Dual Registered",
};

export const transitionStatusMap: Record<TransitionStatus, string> = {
  OnTrack: "On Track",
  Delayed: "Delayed",
  OffTrack: "Off Track",
};

export const onboardingStatusMap: Record<OnboardingStatus, string> = {
  InRecruiting: "In Recruiting",
  KickoffComplete: "Kickoff Complete",
  TransitionInProgress: "Transition In Progress",
  LaunchComplete: "Launch Complete",
  Delayed: "Delayed",
};

export const sentimentMap: Record<Sentiment, string> = {
  Good: "Good",
  Mixed: "Mixed",
  Low: "Low",
  AtRisk: "At Risk",
};

export const transitionPhaseMap: Record<TransitionPhase, string> = {
  NotStarted: "Not Started",
  KickOffComplete: "Kick Off Complete",
  PendingRegistration: "Pending Registration",
  NclNoticeSent: "NCL Notice Sent",
  InTransition: "In Transition",
  ReadyForHandoff: "Ready for Handoff",
};

export const famOnboardingStatusMap: Record<FamOnboardingStatus, string> = {
  IntroToFam: "Intro to FAM",
  FamTransitionAnalysis: "FAM Transition Analysis",
  FamAdoptionUnderway: "FAM Adoption Underway",
  FamAdoptionComplete: "FAM Adoption Complete",
};

export const formatPercentage = (value: number) => `${value}%`;

export const joinAdvisorNames = (advisors: AdvisorInfoSchema[]): string => {
  return advisors.map((advisor) => advisor.fullName).join(", ");
};

export const selectFirstTransitionAdvisor = (
  advisors: AdvisorInfoSchema[]
): AdvisorInfoSchema | undefined => {
  return advisors.at(0);
};

export const areAllAdvisorTransitionsComplete = (
  transitions: (TransitionDTO | TransitionDetailsDTO)[]
): boolean => {
  return transitions.length > 0 && transitions.every(isTransitionComplete);
};
